import type { FeedbackWidgetData } from './types';

export const linkToSupport = 'https://support.atlassian.com/contact/#/';

// IMP: Changing the below configuration might break feedback collector as @atlaskit/feedback-collector silently fails with a standard success flag but a 400 error in Network call.

// Different from actual tenant so that real production tenant does not get polluted from testing. This configuration belongs to SDFEEDSTAG project in https://arajpal.atlassian.net.
export const stagingFeedbackWidgetData: FeedbackWidgetData = {
    embeddableKey: '9923424e-09ae-489b-8dd8-4c2e3b68c9f9',
    requestTypeId: '263',
    typeField: {
        fieldId: 'customfield_10105',
        bugDefaultValue: { id: '10311' },
        commentDefaultValue: { id: '10312' },
        suggestionDefaultValue: { id: '10313' },
        questionDefaultValue: { id: '10314' },
        emptyDefaultValue: { id: '10315' },
    },
    customerNameFieldId: 'customfield_10104',
    canBeContactedField: { fieldId: 'customfield_10106', defaultValue: 'Yes' },
    enrollInResearchField: { fieldId: 'customfield_10107', defaultValue: { id: '10316' } },
};

// This configuration belongs to SDFEEDBACK project in https://jira-feedback.atlassian.net.
export const productionFeedbackWidgetData: FeedbackWidgetData = {
    embeddableKey: '89a920ff-0dca-4035-9428-b7e418c4a4c6',
    requestTypeId: '34',
    typeField: {
        fieldId: 'customfield_10075',
        bugDefaultValue: { id: '10171' },
        commentDefaultValue: { id: '10172' },
        suggestionDefaultValue: { id: '10173' },
        questionDefaultValue: { id: '10174' },
        emptyDefaultValue: { id: '10175' },
    },
    customerNameFieldId: 'customfield_10033',
    canBeContactedField: { fieldId: 'customfield_10038', defaultValue: 'Yes' },
    enrollInResearchField: { fieldId: 'customfield_10074', defaultValue: { id: '10169' } },
};
